import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ProviderType } from "../models/ProviderType";

interface ProviderState {
    value: {
        bank_selected: ProviderType | null,
        providers: ProviderType[]
    };
}

const initialState: ProviderState = {
    value: {
        bank_selected: null,
        providers: [{
            bank_codes: [],
            connection_type: "",
            display_name: "",
            name: "",
            popular: "",
            priority: null,
            third_party: "",
        }]
    }
}

export const providerSlice = createSlice({
    name: 'provider',
    initialState,
    reducers: {
        saveProvidersList: (state, action: PayloadAction<ProviderType[]>) => {
            state.value.providers = action.payload;
        },
        selectBank: (state, action: PayloadAction<ProviderType>) => {
            state.value.bank_selected = action.payload;
        },
        clearBank: (state) => {
            state.value.bank_selected = initialState.value.bank_selected;
        } 
    },
})

export const {saveProvidersList, selectBank, clearBank} = providerSlice.actions;

export default providerSlice.reducer;